import { render, staticRenderFns } from "./ModalCategoryRoute.vue?vue&type=template&id=6bd96057"
import script from "./ModalCategoryRoute.vue?vue&type=script&lang=js"
export * from "./ModalCategoryRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports